import React from 'react';
import { Switch, Route } from 'react-router-dom';

import Login from '../../../modulos/credenciamento/containers/login/Login';
import Evento from '../../../modulos/credenciamento/containers/login/Evento';
import Produtos from '../../../modulos/credenciamento/containers/produtos/Produtos';
import Cadastro from '../../../modulos/credenciamento/containers/cadastro/Cadastro';
import Credencial from '../../../modulos/credenciamento/containers/credencial/Credencial';
import Pendencias from '../../../modulos/credenciamento/containers/pendencias/Pendencias';

class CredenciamentoNavegacao extends React.Component {
    render(){
        return (            
            <Switch>
                <Route exact path={`${this.props.match.path}/:promotora/:evento`} component={Evento} />                
                <Route exact path={`${this.props.match.path}/:promotora/:evento/produtos`} component={Produtos} />
                <Route exact path={`${this.props.match.path}/:promotora/:evento/login`} component={Login} />
                <Route exact path={`${this.props.match.path}/:promotora/:evento/cadastro`} component={Cadastro} />
                <Route exact path={`${this.props.match.path}/:promotora/:evento/credencial`} component={Credencial} />
                <Route exact path={`${this.props.match.path}/:promotora/:evento/:categoria`} component={Evento} />
                <Route exact path={`${this.props.match.path}/:promotora/:evento/pendencias/:idpromotora/:idcredencial/:idevento`} component={Pendencias} />
            </Switch>
        )
    }
}

export default CredenciamentoNavegacao;